import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { Label } from '../../../../services/eleview/types/label';
import { Node } from '../../../../services/eleview/types/node';
import { LabelManagerService } from '../../service/label-manager.service';
import { MatDialog } from '@angular/material';
import { EditLabelComponent } from '../../edit-label/edit-label.component';

@Component({
	selector: 'common-label-for-edit',
	templateUrl: './label-for-edit.component.html',
	styleUrls: ['./label-for-edit.component.scss']
})
export class LabelForEditComponent implements OnInit {
	@Input() label: Label;
	@Input() categoryID: string;
	@HostBinding('class.label-for-edit') hostClass = true;

	removeConfirm = false;
	constructor(public svr: LabelManagerService, private dialog: MatDialog) {}
	ngOnInit() {}
	edit() {
		this.svr.backface.fetchLabel({ CategoryID: this.categoryID, ID: this.label.ID }).subscribe(v => {
			this.svr.backface.stringToNode(v.Conts).subscribe(conts => {
				this.svr.editLabel.titleInput = false;
				this.svr.editLabel.CategoryID = this.categoryID;
				this.svr.editLabel.LabelID = this.label.ID;
				this.svr.editLabel.isAdd = false;
				this.svr.editLabel.Name = v.Name;
				this.svr.editLabel.Conts = Node.fromInterface(conts);
				this.svr.editLabel.PlainText = v.PlainText;
				this.dialog.open(EditLabelComponent, {
					width: '800px',
					height: '100%',
					minWidth: '800px',
					disableClose: true,
					data: this.svr,
					position: {
						top: '0px',
						right: '0px'
					}
				});
			});
		});
	}
	remove() {
		this.svr.removeLabel(this.categoryID, this.label.ID).subscribe(() => (this.removeConfirm = false));
	}
}
